import type { AvailableLanguages } from '../types/localization.types'

export const AVAILABLE_LANGUAGES: AvailableLanguages[] = [
  'en',
  'nl',
  'de',
  'fr',
  'pl'
]
